document.addEventListener("DOMContentLoaded", function() {
  // Get all the details elements for the main menu and second-level menu
  const mainMenuDetails = document.querySelectorAll('.header__menu-item');
  const secondLevelDetails = document.querySelectorAll('.header__submenu details');

  // Function to close all submenus
  function closeAllSubmenus() {
    secondLevelDetails.forEach((detail) => {
      detail.removeAttribute('open');
    });
  }

  // Close all submenus when a main menu item is clicked
  mainMenuDetails.forEach((menuItem) => {
    menuItem.addEventListener('click', function() {
      closeAllSubmenus();
    });
  });

  // Close other submenus when a second-level submenu item is clicked
  secondLevelDetails.forEach((detail) => {
    detail.addEventListener('click', function(event) {
      // Prevent main menu click event from closing submenus immediately
      event.stopPropagation();
      // Close all other details elements
      secondLevelDetails.forEach((otherDetail) => {
        if (otherDetail !== detail) {
          otherDetail.removeAttribute('open');
        }
      });
    });
  });
});





